import { memo, useCallback } from 'react';
import { TableProps } from '../..';
import { Flex, Popover, PopoverTrigger, Button, PopoverContent, Link } from '@chakra-ui/react';
import * as Styles from '../../styles';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { checkPermission } from 'utils/authentication';
import { useRouteMatch } from 'react-router-dom';
import { useHistory } from 'react-router';

interface BodyProps {
  rows: TableProps['rows'];
  sizes: string;
  row: TableProps['row'];
  path?: string | undefined;
  locations?: string[];
}

const BodyComponent: React.FC<BodyProps> = ({ rows, sizes, row, path, locations }) => {
  const router = useRouteMatch();
  const routeDemandsSAndParms = `${router.path}?page=0`;
  const history = useHistory();
  const clickHandle = useCallback(
    index => {
      if (locations) history.push(locations[index]);
    },
    [locations],
  );
  return (
    <Styles.TableBody>
      {rows.map((tr, trIndex) => (
        <Flex
          key={trIndex}
          align={'center'}
          marginBottom={'10px'}
          cursor={locations ? 'pointer' : ''}
          onClick={() => clickHandle(trIndex)}
        >
          <Styles.Tr sizes={sizes} key={`tr-${trIndex}`}>
            {tr.map((td, tdIndex) => (
              <Styles.Td key={`td-${tdIndex}`}>{td || '-'}</Styles.Td>
            ))}
          </Styles.Tr>
          {checkPermission({ onlyAdmin: true }) &&
          routeDemandsSAndParms !== '/demands?page=0' &&
          !routeDemandsSAndParms.includes('/budgetControl') ? (
            <Flex alignItems={'center'} marginLeft={'10px'} className="containerFlex">
              <Popover>
                <PopoverTrigger>
                  <Button className="boxPopover">
                    <BsThreeDotsVertical />
                  </Button>
                </PopoverTrigger>

                <PopoverContent className="cardEdit" left={'-5rem'} top={'-3.5rem'}>
                  <Link href={'/' + path + row[trIndex]}>Editar</Link>
                </PopoverContent>
              </Popover>
            </Flex>
          ) : (
            ''
          )}
        </Flex>
      ))}
    </Styles.TableBody>
  );
};

export const Body = memo(BodyComponent);
